import type { InfractionText } from './types';

export const portServiceVulnerableI18n: Record<string, InfractionText> = {
  CRITICAL_VULN_SERVICE: {
    infraction: '{service} (version {version}) with known vulnerability',
    explanation: `{summary}`,
    whyRisk: 'Why is this a critical risk?',
    risk: 'Critical severity vulnerabilities (CVSS ≥ 9.0) are commonly used in active exploitation and may allow remote code execution, privilege escalation, or unauthenticated access. The presence of this vulnerability represents a clear and immediate threat to system integrity and should be addressed urgently.',
  },
  HIGH_VULN_SERVICE: {
    infraction: '{service} (version {version}) with known vulnerability',
    explanation: `{summary}`,
    whyRisk: 'Why is this a high risk?',
    risk: 'High severity vulnerabilities (CVSS 7.0–8.9) can enable attackers to compromise data, bypass protections, or gain access to internal systems. If verified or associated with high exploitation likelihood, the urgency for remediation increases significantly.',
  },
  MEDIUM_VULN_SERVICE: {
    infraction: '{service} (version {version}) with known vulnerability',
    explanation: `{summary}`,
    whyRisk: 'Why is this a medium risk?',
    risk: 'Medium severity issues (CVSS 4.0–6.9) may require specific conditions, configurations, or user interaction to exploit. While not immediately dangerous alone, they may be chained with other vulnerabilities or exploited opportunistically.',
  },
  LOW_VULN_SERVICE: {
    infraction: '{service} (version {version}) with known vulnerability',
    explanation: `{summary}`,
    whyRisk: 'Why is this a low risk?',
    risk: 'Low severity vulnerabilities (CVSS < 4.0) typically result in minimal impact or require complex conditions to exploit. However, they may still indicate unpatched software or attack surface bloat, which should be monitored and eventually remediated.',
  },
};
